import * as types from '../mutation-types';
import Lesson from '~/models/lesson';
import axios from 'axios';

// state
export const state = {
  collection: [],
  model: null,
};

// getters
export const getters = {
  lessons: state => state.collection,
  lesson: state => state.model,
};

// mutations
export const mutations = {
  [types.LESSONS_FETCH_ALL] (state, modelsData) {
    const collection = [];
    modelsData.forEach(data => {
      collection.push(new Lesson(data));
    });
    state.collection = collection;
  },
  [types.LESSONS_CLEAR] (state) {
    state.model = null;
  },
  [types.LESSONS_FIND] (state, data) {
    state.model = new Lesson(data);
  },
  [types.LESSONS_CREATE] (state, data) {
    state.collection.push(new Lesson(data));
  },
  [types.LESSONS_UPDATE] (state, data) {
    const index = state.collection.findIndex(el => el.compareId(data.id));
    if (index !== -1) {
      state.collection[index].data = data;
    }
    if (state.model && state.model.compareId(data.id)) {
      state.model.data = data;
    }
  },
  [types.LESSONS_REMOVE] (state, id) {
    state.collection.splice(state.collection.findIndex(c => c.compareId(id)), 1);

    if (state.model && state.model.compareId(id)) {
      state.model = null;
    }
  },
};

const getBaseURL = (courseId) => `/api/courses/${courseId}/lessons`;

// actions
export const actions = {
  async fetchAll ({ commit }, courseId) {
    const { data } = await axios.get(getBaseURL(courseId));
    commit(types.LESSONS_FETCH_ALL, data);
  },
  clearLesson ({ commit }) {
    commit(types.LESSONS_CLEAR);
  },
  async find ({ commit }, { courseId, lessonId }) {
    const { data } = await axios.get(`${getBaseURL(courseId)}/${lessonId}`);
    commit(types.LESSONS_FIND, data);
  },
  async create ({ commit }, { courseId, form }) {
    const { data } = await form.post(`${getBaseURL(courseId)}/create`);
    commit(types.LESSONS_CREATE, data);
  },
  async update ({ commit }, { courseId, lessonId, form }) {
    const { data } = await form.patch(`${getBaseURL(courseId)}/${form.id}`);
    commit(types.LESSONS_UPDATE, data);
  },
  async remove ({ commit }, { courseId, lessonId }) {
    await axios.delete(`${getBaseURL(courseId)}/${lessonId}`);
    commit(types.LESSONS_REMOVE, lessonId);
  },
};
